import React from 'react';
import {DmsTab, DisplayForm} from '../../components';
import {Button, Tabs, Table, Input} from 'antd';
const TabPane = Tabs.TabPane;
import '../order/order.css';
import { formatMoney, openNotice } from 'Utils';

class SecondCusOrderDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['订单详情'],
            defaultActiveKey: 1,
            detailData: {},
            sendData: {
                'orderDeliveryItemList': [],
                'logisticsCompany': '',
                'logisticsCode': ''
            }
        }
    }

    initData (key) {

    }

    componentDidMount () {

    }

    backTo() {
        window.history.go(-1);
    }

    tabClickFn(key) {
		/* 页签点击 */
        this.setState({defaultActiveKey: key});
    }

    changeInputSendFn (index, field, value) {

    }

    render() {
        const {opts, defaultActiveKey, detailData, sendData} = this.state;
        let self = this;
        const productProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '序号',
                    dataIndex: 'id'
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine'
                },
                {
                    title: '品牌',
                    dataIndex: 'name123123'
                },
                {
                    title: '物料编码',
                    dataIndex: 'productCode '
                },
                {
                    title: '物料描述',
                    dataIndex: 'name1'
                },
                {
                    title: '库存属性',
                    dataIndex: 'name2'
                },
                {
                    title: '牌价',
                    dataIndex: 'price'
                },
                {
                    title: '下浮价',
                    dataIndex: 'nam1xxx'
                },
                {
                    title: '下浮率',
                    dataIndex: 'nam1xxxa'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '参考可用量',
                    dataIndex: 'availableReferenceQuantity'
                },
                {
                    title: '开单数量',
                    dataIndex: 'count'
                },
                {
                    title: '装箱数',
                    dataIndex: 'name3'
                },
                {
                    title: '最小起订量',
                    dataIndex: 'nam1'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                }
            ],
            dataSource: detailData.productList || []
        };
        const shippedProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'productName'
                }, {
                    title: '物料编码',
                    dataIndex: 'specUnionKey'
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '待发数量/订单数量',
                    dataIndex: 'id',
                    render: (text, record, index) => {
                        return <span>{`${record.undeliveredCount}/${record.count}`}</span>
                    }
                }, {
                    title: '待发金额(元)',
                    dataIndex: 'undeliveredCount',
                    render: (text, record, index) => {
                        return <span>{formatMoney((record.undeliveredCount*record.price).toFixed(2))}</span>
                    }
                }
            ],
            dataSource: detailData.undeliveredList || []
        };
        const stayProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'productName'
                }, {
                    title: '物料编码',
                    dataIndex: 'productSpec'
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '发货数量',
                    dataIndex: 'count'
                }, {
                    title: '出库单号',
                    dataIndex: 'storage'
                }, {
                    title: '发货日期',
                    dataIndex: 'orderDeliveryCode'
                }, {
                    title: '收货日期',
                    dataIndex: 'deliverDate'
                }, {
                    title: '配送物流公司',
                    dataIndex: 'receiveDate'
                }, {
                    title: '物流单号',
                    dataIndex: 'xxxxxxx'
                }, {
                    title: '',
                    dataIndex: 'action',
                    render: () => {
                        return <Button type="primary">收货</Button>
                    }
                }
            ],
            dataSource: detailData.deliveredList || []
        };
        const sendProps = {
            rowKey: 'id',
            columns: [
                {
                    title: '产品名称',
                    dataIndex: 'productName'
                }, {
                    title: '规格',
                    dataIndex: 'specUnionKey'
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                }, {
                    title: '待发数量',
                    dataIndex: 'undeliveredCount'
                }, {
                    title: '发货仓库-货位',
                    dataIndex: 'storageLocal'
                }, {
                    title: '可用量',
                    dataIndex: 'availableCount'
                }, {
                    title: '发货数量',
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        return <Input type="number" value={text} onChange={this.changeInputSendFn.bind(this, index, 'count')} placeholder="请输入发货数量" />
                    }
                }
            ],
            dataSource: sendData.orderDeliveryItemList || []
        };
        const displayData = [
            {label: '订单单号', value: ''},
            {label: '客户名称', value: ''},
            {label: '订单日期', value: ''},
            {label: '订单整体折扣', value: ''},
            {label: '订单状态', value: ''},
            {label: '提交人', value: ''},
            {label: '联系电话', value: ''},
            {label: '联系人', value: ''},
            {label: '实际收货地址', value: ''},
            {label: '备注', value: ''}
        ];
        return <div>
			<DmsTab options={opts} defaultKey={0}>
                <Button type="primary">转天正订单</Button>
				<Button type="primary">审核</Button>
				<Button type="primary">发货</Button>
				<Button type="primary">收货</Button>
				<Button onClick={this.backTo.bind(this)}>返回</Button>
			</DmsTab>
			<div className="dms-table-box">
                <DisplayForm dataSource={displayData} perRow="4"/>
				<div className="dms-table-box">
                    <Tabs defaultActiveKey={defaultActiveKey + ''} onChange={self.tabClickFn.bind(self)}>
                        <TabPane tab="订单详情" key="1">
                            <div>
                                <DmsTab className="white-bg no-border" options={['订单商品']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <Table {...productProps} bordered pagination={true}/>
                                </div>
                                <div className="order_amount">
                                    <p><span className="right">商品总金额：¥516,541</span></p>
                                    <p><span className="right">优惠金额：¥516,541</span></p>
                                    <p><span className="right">优惠金额：<font>¥45,321</font></span></p>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="发货记录" key="2" disabled={detailData.status==1?true:false}>
                            <div>
                                <DmsTab className="white-bg no-border" options={['待发货']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <Table {...shippedProps} bordered pagination={false}/>
                                </div>
                            </div>
                            <div>
                                <DmsTab className="white-bg no-border" options={['已发货']} defaultKey={0}></DmsTab>
                                <div className="dms-table-box">
                                    <Table {...stayProps} bordered pagination={false}/>
                                </div>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
			</div>

		</div>
    }
};
export default SecondCusOrderDetail;



// WEBPACK FOOTER //
// ./src/routes/secCusOrder/detail.js